import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../system/thead";
import TableTdContent from "../system/tableTdContent";
import {PaginateContext} from "../../context/paginate";


const TABLE_HEAD = ["#", "عنوان", "توضیحات", "گرایش", "وضعیت", "عملیات"];

export function BranchDocumentGrid({
                                     BranchDocuments,
                                     setModalOpen,
                                     setSelectedRow,
                                   }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "عنوان": "title",
    "توضیحات": "description",
    "گرایش": "branch_title",
    "وضعیت": "status",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "عنوان": true,
    "توضیحات": true,
    "گرایش": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {BranchDocuments.map(
          ({id, title, description, branch_title, status}, index) => {
            const isLast = index === BranchDocuments.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <TableTdContent content={title}/>
                </td>

                <td className={classes}>
                  <TableTdContent content={description} length={40}/>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setSelectedRow(BranchDocuments[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}